import { getRayon, getGorod } from "../../../utilities";

export const fieldApplicantInformation = {
  selfTraining: {
    key: "selfTraining",
    label: "Самоподготовка",
    type: "selectWithSearch",
    defaultValue: null,
    readOnly: false,
    isSearchable: false,
    required: true,
    options: [
      {
        value: 1,
        label: "Да",
        key: "selfTraining",
      },
      {
        value: 2,
        label: "Нет",
        key: "selfTraining",
      },
    ],
    needInForm: true,
  },
  programId: {
    key: "programId",
    label: "Программа подготовки",
    type: "selectWithSearch",
    defaultValue: null,
    readOnly: false,
    isSearchable: true,
    required: true,
    options: [],
    needInForm: true,
  },
  persNum: {
    key: "persNum",
    label: "Идентификационный номер",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
    maxlength: 15,
    needInForm: true,
  },
  address: {
    key: "address",
    label: "Адрес",
    type: "text",
    textarea: "textarea",
    rows: 4,
    defaultValue: null,
    readOnly: false,
    required: true,
    needInForm: true,
  },
  surname: {
    key: "surname",
    label: "Фамилия",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
    needInForm: true,
  },
  name: {
    key: "name",
    label: "Имя",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
    needInForm: true,
  },
  midname: {
    key: "midname",
    label: "Отчество",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: false,
    needInForm: true,
  },
  docType: {
    key: "docType",
    label: "Документ",
    type: "selectWithSearch",
    options: [],
    required: true,
    needInForm: true,
  },
  serialOfPassport: {
    key: "serialOfPassport",
    label: "Серия",
    type: "text",
    required: true,
    needInForm: true,
  },
  birthDate: {
    key: "birthDate",
    label: "Дата рождения",
    type: "date",
    readOnly: false,
    required: true,
    needInForm: true,
    customButton: true,
  },
  numberOfPassport: {
    key: "numberOfPassport",
    label: "Номер",
    type: "text",
    required: true,
    needInForm: true,
  },
  docDateIssue: {
    key: "docDateIssue",
    label: "Дата выдачи:",
    type: "date",
    required: true,
    needInForm: true,
  },
  phone: {
    key: "phone",
    label: "Телефон",
    type: "text",
    readOnly: false,
    required: true,
    needInForm: true,
  },
  docDepartment: {
    key: "docDepartment",
    label: "Кем выдан",
    type: "text",
    required: true,
    needInForm: true,
  },
  birthPlace: {
    key: "birthPlace",
    label: "Место рождения",
    type: "text",
    readOnly: false,
    required: true,
    needInForm: true,
  },
};

export const fieldTrainingInformation = {
  trainingOrgsName: {
    key: "trainingOrgsName",
    label: "Наименование организации, осуществившей обучение",
    type: "text",
    readOnly: false,
    required: true,
    needInForm: true,
  },
  trainingDocTypes: {
    key: "trainingDocTypes",
    label: "Вид документа",
    type: "selectWithSearch",
    isDisabled: false,
    isSearchable: false,
    required: true,
    options: [],
    needInForm: true,
  },
  trainingDocumentsDocNum: {
    key: "trainingDocumentsDocNum",
    label: "Серия, номер",
    type: "text",
    readOnly: false,
    required: true,
    needInForm: true,
  },
  trainingDocumentsDocDate: {
    key: "trainingDocumentsDocDate",
    label: "Дата выдачи",
    type: "date",
    readOnly: false,
    required: true,
    needInForm: true,
  },
  trainingDocumentsDateStart: {
    key: "trainingDocumentsDateStart",
    label: "Период обучения с",
    type: "date",
    readOnly: false,
    required: true,
    needInForm: true,
  },
  trainingDocumentsDateEnd: {
    key: "trainingDocumentsDateEnd",
    label: "Период обучения по",
    type: "date",
    readOnly: false,
    required: true,
    needInForm: true,
  },
};

export const fieldMedicalCertificate = {
  documentMedicalDocNum: {
    key: "documentMedicalDocNum",
    label: "Номер",
    type: "number",
    readOnly: false,
    required: true,
    needInForm: true,
  },
  documentMedicalDocDate: {
    key: "documentMedicalDocDate",
    label: "Дата выдачи",
    type: "date",
    readOnly: false,
    required: true,
    needInForm: true,
  },
  documentMedicalPeriod: {
    key: "documentMedicalPeriod",
    label: "Срок действия, лет",
    type: "number",
    readOnly: false,
    required: true,
    needInForm: true,
  },
};
export const fieldFooter = {
  file: {
    key: "file",
    label: "Файл фото:",
    type: "file",
    readOnly: false,
    required: false,
    needInForm: true,
  },
  appDate: {
    key: "appDate",
    label: "Дата подачи заявления:",
    type: "date",
    readOnly: false,
    required: true,
    needInForm: true,
  },
  appUser: {
    key: "appUser",
    label: "Должностное лицо:",
    type: "selectWithSearch",
    readOnly: true,
    disabled: true,
    required: false,
    needInForm: true,
    options: [],
  },
};

export async function setOptions(id, key) {
  if (id) {
    switch (key) {
      case "oblastId": {
        fieldApplicantInformation.rayonId.options = await getRayon(id);
        fieldApplicantInformation.rayonId.disabled = fieldApplicantInformation.rayonId.options.length
          ? false
          : true;
        fieldApplicantInformation.gorodId.options = [];
        fieldApplicantInformation.gorodId.disabled = true;
        return fieldApplicantInformation;
      }
      case "rayonId": {
        fieldApplicantInformation.gorodId.options = await getGorod(id);
        fieldApplicantInformation.gorodId.disabled = fieldApplicantInformation.gorodId.options.length
          ? false
          : true;
        return fieldApplicantInformation;
      }
      default:
        return fieldApplicantInformation;
    }
  }
}
export function getOptions(mode) {
  if (mode === "view") {
    fieldFooter.file.needInForm = false;
  } else {
    fieldFooter.file.needInForm = true;
  }
  return {
    applicant: fieldApplicantInformation,
    training: fieldTrainingInformation,
    medical: fieldMedicalCertificate,
    footer: fieldFooter,
  };
}

export const setOptionsForInputsTrainingProgram = (inputsOptions) => {
  if (fieldApplicantInformation.programId.options.length === 0) {
    fieldApplicantInformation.programId.options.push(...inputsOptions);
  }
};

export const toggleTrainingInformationRequired = (requiredIn) => {
  for (let key in fieldTrainingInformation) {
    fieldTrainingInformation[key].required = !requiredIn;
  }
};

export function setTrainingDocOptionsFromDictionaries(lib) {
  if (lib.length > 0) {
    const validLib = lib.map((item) => {
      return {
        ...item,
        key: "trainingDocTypes",
      };
    });
    if (fieldTrainingInformation.trainingDocTypes.options.length === 0) {
      fieldTrainingInformation.trainingDocTypes.options.push(...validLib);
    }
  }
}

export function setDocOptionsAppKnowledgeVerificationFromDictionaries(docLib) {
  if (docLib.length > 0) {
    const validLib = docLib.map((item) => {
      return {
        ...item,
        key: "docType",
      };
    });
    if (fieldApplicantInformation.docType.options.length === 0) {
      fieldApplicantInformation.docType.options.push(...validLib);
    }
  }
}
export function setAppUserOptions(lib) {
  if (fieldFooter.appUser.options.length === 0) {
    fieldFooter.appUser.options.push(...lib);
  }
  return {
    applicant: fieldApplicantInformation,
    training: fieldTrainingInformation,
    medical: fieldMedicalCertificate,
    footer: fieldFooter,
  };
}
